import { InputText } from 'primereact/inputtext'
import { useEffect } from 'react'

import { Flex } from '../../../../Components'
import { FieldWrapper } from '../../../../Components/Form'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { FloatInput } from './InputForm'

const language = cap.language.state || 'IT'
const lang = language.toLowerCase()
const t = translations[language]

export const TravellerInput = ({
  state: [state, setState],
  value: [value, setValue],
  item,
  secondItem,
  count,
  readOnly,
  miss: [error, setError],
  variant
}) => {
  const { type, label, id, options, minDate } = item

  useEffect(() => {
    if (error && value) setError(false)
  }, [value, error, setError])

  if (variant === 'v2') {
    const fieldId = `${count ?? ''}${id}`
    return (
      <div className="ff-grid__item">
        <FieldWrapper
          id={fieldId}
          label={label?.[lang] || label?.it}
          error={error ? t.gfCampoObbligatorio : undefined}
        >
          <InputText
            id={fieldId}
            value={value || ''}
            onChange={(e) => setValue(e.target.value)}
            disabled={readOnly}
            className={error ? 'p-invalid' : undefined}
            style={{ width: '100%' }}
          />
        </FieldWrapper>
      </div>
    )
  }

  return (
    <>
      <Flex key={item.id} as js style={{ width: '23%', margin: '0px 1%' }}>
        <FloatInput
          value={[value, setValue]}
          id={count + id}
          label={label?.[lang] || label?.it}
          type={type}
          options={options}
          readOnly={readOnly}
          minDate={minDate}
          error={error}
        />
      </Flex>
    </>
  )
}
